export const DEFAULT_INTERVIEW_NAME = 'Interview';
